export type ThemeMode = "light" | "dark" | "system";

// Serialized into the initial HTML as well; keep this function self-contained.
export function getThemeMode(state: unknown): ThemeMode {
  if (!state || typeof state !== "object") return "light";
  const saved = state as { colorMode?: unknown; darkMode?: unknown };
  if (saved.colorMode === "light" || saved.colorMode === "dark" || saved.colorMode === "system") {
    return saved.colorMode;
  }
  if (typeof saved.darkMode === "boolean") return saved.darkMode ? "dark" : "light";
  return "light";
}
